// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d440e1ab","404":"e7a0606c","498":"c77f5a0f","787":"e6aad586"}[chunkId] + ".chunk.js";
};